import type { components } from "@/shared/api";

export type FriendsPeriod = components["schemas"]["FriendsPeriod"];

// Периоды экрана: 7 дней, 30 дней и вся история.
export const FRIENDS_PERIODS = ["week", "month", "all"] as const satisfies readonly FriendsPeriod[];

// Без параметра в адресе — месяц, как у бэкенда.
export const DEFAULT_FRIENDS_PERIOD: FriendsPeriod = "month";
